// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSlider_switch__DnMlP","slider":"ToggleSlider_slider__jwlbf"};